import React from 'react'

const RightNav = () => {
  return (
    <div>&nbsp;</div>
  )
}
export default RightNav